import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { WidgetModule } from './widget/widget.module';
import { CopyrightComponent } from './copyright/copyright.component';
import { FluidHeightDirective } from 'src/app/directives/fluid-height.directive';
import { IsGrantedDirective } from '../directives/is-granted.directive';

@NgModule({
  declarations: [PagetitleComponent, CopyrightComponent, FluidHeightDirective, IsGrantedDirective],
  imports: [CommonModule, WidgetModule],
  exports: [PagetitleComponent, CopyrightComponent, FluidHeightDirective,IsGrantedDirective],
})
export class SharedModule {}
